<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  export default {
    name: 'App',
    computed: mapGetters(['statusDic']),
    methods: mapActions(['setStatusDic']),
    created() {
      if (this.statusDic===null) {
        this.setStatusDic();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue